"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LLM_PLATFORMS = exports.LLMPlatform = void 0;
exports.LLMPlatform = {
    CHATGPT: "chatgpt",
    PERPLEXITY: "perplexity",
    GEMINI: "gemini",
    CLAUDE: "claude",
};
exports.LLM_PLATFORMS = [
    exports.LLMPlatform.CHATGPT,
    exports.LLMPlatform.PERPLEXITY,
    exports.LLMPlatform.GEMINI,
    exports.LLMPlatform.CLAUDE,
];
